/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Action_Login_Invalid_DescInputs */

const en_action_login_invalid_desc = /** @type {(inputs: Action_Login_Invalid_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The login link is invalid or has expired. Please use the login page to sign in.`)
};

const de_action_login_invalid_desc = /** @type {(inputs: Action_Login_Invalid_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Anmelde-Link ist ungültig oder abgelaufen. Bitte melden Sie sich über die Login-Seite an.`)
};

/**
* | output |
* | --- |
* | "The login link is invalid or has expired. Please use the login page to sign in." |
*
* @param {Action_Login_Invalid_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const action_login_invalid_desc = /** @type {((inputs?: Action_Login_Invalid_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Action_Login_Invalid_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_action_login_invalid_desc(inputs)
	return en_action_login_invalid_desc(inputs)
});